/* KEFIT — Infinite scroll for collection pages
   Place in: assets/kefit-infinite-scroll.js
   Works with the [data-kefit-infinite] block in sections/kefit-collection.liquid
   Also keeps working after filters / sorting reload the grid. */
(function () {
  'use strict';

  var loading = false;
  var observer = null;
  var observed = null;

  function getSentinel() {
    return document.querySelector('[data-kefit-infinite]');
  }

  function showButton(sentinel, show) {
    var btn = sentinel && sentinel.querySelector('[data-kefit-infinite-btn]');
    if (btn) btn.hidden = !show;
  }

  function observe() {
    var sentinel = getSentinel();
    if (!sentinel) {
      if (observer) observer.disconnect();
      observed = null;
      return;
    }
    if (sentinel === observed) return;
    observed = sentinel;

    // Old browsers: just show the button
    if (!('IntersectionObserver' in window)) {
      showButton(sentinel, true);
      return;
    }

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) loadNext();
      },
      { rootMargin: '700px 0px' } // start loading before the user reaches the end
    );
    observer.observe(sentinel);
  }

  function loadNext() {
    if (loading) return;
    var sentinel = getSentinel();
    if (!sentinel) return;

    var url = sentinel.getAttribute('data-next-url');
    if (!url) return;

    loading = true;
    sentinel.classList.add('is-loading');
    showButton(sentinel, false);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-kefit-product-grid]');
        var grid = document.querySelector('[data-kefit-product-grid]');
        if (!newGrid || !grid) throw new Error('Grid not found');

        var cards = newGrid.querySelectorAll('.kefit-collection__product-card');
        var added = [];
        var frag = document.createDocumentFragment();
        cards.forEach(function (card) {
          var node = document.importNode(card, true);
          added.push(node);
          frag.appendChild(node);
        });
        grid.appendChild(frag);

        var newSentinel = doc.querySelector('[data-kefit-infinite]');
        var current = getSentinel();
        if (current) {
          if (newSentinel) {
            current.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          } else {
            current.remove(); // no more pages
          }
        }

        document.dispatchEvent(
          new CustomEvent('kefit:products-appended', { detail: { cards: added } })
        );
      })
      .catch(function () {
        var current = getSentinel();
        if (current) showButton(current, true); // let the user tap "Load more"
      })
      .then(function () {
        loading = false;
        var current = getSentinel();
        if (current) {
          current.classList.remove('is-loading');
          observed = null; // re-observe so it fires again if still visible
          observe();
        }
      });
  }

  // Button (fallback)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kefit-infinite-btn]');
    if (btn) {
      e.preventDefault();
      loadNext();
    }
  });

  // Re-connect after filters / sort replace the grid
  var root = document.querySelector('[data-kefit-collection]') || document.body;
  new MutationObserver(function () {
    if (getSentinel() !== observed) observe();
  }).observe(root, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
